import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Request } from "@/types/research.types";

interface ExecuteAutomationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  request: Request | null;
}

const ExecuteAutomationDialog: React.FC<ExecuteAutomationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  request,
}) => {
  if (!request) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-4 sm:max-w-[400px]">
        <DialogHeader className="sm:text-center">
          <DialogTitle className="text-base font-semibold text-center">
            Start One Click Automation
          </DialogTitle>
          <DialogDescription className="text-center text-sm pt-2">
            Do you want to send all chain requests for &quot;{request.name}&quot;?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-row gap-2 sm:justify-center mt-4">
          <Button variant="outline" onClick={onClose} className="flex-1">
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 bg-primary-300 hover:bg-primary-400"
          >
            Yes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExecuteAutomationDialog;
